import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';

const mapStateToProps = ({ ScreensData = {} }, { currentForm = '' }) => {
  const { submitForm = null } = ScreensData;
  return {
    shouldSubmit: submitForm === currentForm,
  };
};
export default (WrappedComponent) => compose(
  withRouter,
  connect(mapStateToProps, {}),
)(WrappedComponent);
